// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"1bae1d3b","450":"ad8fa6ff"}[chunkId] + ".chunk.js";
};